import React from "react";

function Coverage() {
  return (
    <div style={{ padding: "30px" }}>
      <h1>Coverage Options</h1>
      <p>
        Explore available vehicle-related coverage options.  
        This section will include partner links once approved.
      </p>

      <div style={{ marginTop: "30px", padding: "20px", background: "#f2f2f2" }}>
        <h3>Coming Soon</h3>
        <p>
          Partner coverage options will be displayed here after approval.
        </p>
      </div>
    </div>
  );
}

export default Coverage;
